import { useEffect, useRef, useState } from 'react'
import { io, Socket } from 'socket.io-client'
import { useDispatch } from 'react-redux'
import { setSocketRefetch } from 'config/user/store/socketRefetchSlice'
import storage from 'utils/storage'

const basePath = process.env.REACT_APP_SOCKET_BASE_PATH_URL
const handShakePath = process.env.REACT_APP_SOCKET_HANDSHAKE_PATH

const ConnectSocket = () => {
  const [authToken, setAuthToken] = useState<string>(storage.getToken() ?? '')
  const socketRef = useRef<Socket | null>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (authToken) {
      const newSocket = io(basePath, {
        reconnection: true,
        reconnectionAttempts: 30,
        reconnectionDelay: 2000,
        path: handShakePath,
        transports: ['websocket'],
        query: { token: `Bearer ${authToken}` },
      })
      newSocket.on('connect', () => {
        console.log('Socket connected to server:', newSocket.id)
      })
      newSocket.on('disconnect', () => {
        console.log('Disconnected from WebSocket server')
      })
      newSocket.on('data', data => {
        console.log('data on socket', data)
      })
      newSocket.on('inspeq_job_status_updated', data => {
        dispatch(setSocketRefetch(Math.random()))
      })
      newSocket.on('new_notification', data => {
        dispatch(setSocketRefetch(Math.random()))
      })
      // Disconnect the previous socket if it exists.
      socketRef.current?.disconnect()
      socketRef.current = newSocket
    }
    return () => {
      socketRef.current?.disconnect()
    }
  }, [authToken, dispatch])

  useEffect(() => {
    const tokenCheckInterval = setInterval(() => {
      const currentToken = storage.getToken() ?? ''
      if (currentToken !== authToken) {
        setAuthToken(currentToken)
      }
      if (!currentToken && socketRef.current?.connected) {
        socketRef.current.disconnect()
      }
    }, 3000)
    return () => clearInterval(tokenCheckInterval)
  }, [authToken])

  return null
}

export default ConnectSocket
